import { createApp } from 'vue';
import { createStore } from 'vuex';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './views/HomePage.vue';
import AboutPage from './views/AboutPage.vue';
import ProjectPage from './views/Projects.vue';
import ContactPage from './views/Contact.vue';
import ProjectDetails from './views/ProjectDetails.vue';

// const AboutPage = () => import('./views/AboutPage.vue');
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: HomePage, meta: { transition: 'fade' } },
    {
      path: '/about',
      component: AboutPage,
      meta: { transition: 'slide-left' },
    },
    {
      path: '/projets',
      component: ProjectPage,
      meta: { transition: 'slide-left' },
    },
    {
      path: '/contact',
      component: ContactPage,
      meta: { transition: 'slide-left' },
    },
    {
      path: '/projets/:id',
      name: 'projectDetails',
      component: ProjectDetails,
      meta: { transition: 'slide-right' },
    },
  ],
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
});

const store = createStore({
  state() {
    return {
      projects: [
        {
          title: 'Bouygues immobilier',
          description:
            "Développement frontend d'un outil métier pour la création de landing page personnnalisable sur les programmes immobiliers neufs.",
          date: '/2024',
          role: 'Développeuse frontend',
          stack: ['Html', 'Scss', 'Javascript(es6)'],
          illustrations: [
            require('@/assets/bouygues-mockup.png'),
          ],
          image: require('@/assets/bouygues-mockup.png'),
          link: 'https://les-offres.bouygues-immobilier.com/landing-sea',
        },
        {
          title: 'Improov marketing',
          description: 'Intégration de divers jeux concours',
          date: '/2024',
          role: 'Intégratrice',
          stack: ['Html', 'Scss', 'JQuery'],
          illustrations: [
            require('@/assets/Bonux-jeu-asterix.png'),
            require('@/assets/Dolce-vita-Nutimaine.png'),
            require('@/assets/vitakraft.png'),
          ],
          image: require('@/assets/Bonux-jeu-asterix.png'),
          link: 'https://bonux.fr/',
        },
        {
          title: 'Qualitel expertise',
          description:
            "Refont du site internet et migration d'un CMS Typo3 à WordPress.",
          date: '/2024',
          role: 'Intégratrice',
          stack: ['Html', 'Scss', 'Javascript(es6)'],
          illustrations: [
            require('@/assets/quios.png'),
            require('@/assets/quios2.png'),
            require('@/assets/quios3.png'),
          ],
          image: require('@/assets/quios.png'),
          link: 'https://www.qualitel-expertise.fr/',
        },
        {
          title: 'Comparateur Télécom',
          description:
            "Développement d'une application web de comparaison entre les différentes offres mobile et internet.",
          date: '/2018',
          role: 'Développeuse Frontend',
          stack: ['Html', 'Scss', 'Javascript(es6)'],
          video: require('@/assets/selectra.mp4'),
          image: require('@/assets/comparator.png'),
          link: 'https://comparateur.selectra.info/telecom/',
        },
        {
          title: 'Portfolio Sébastien Veyre',
          description: "Intégration du portfolio d'un designer Lyonnais. ",
          date: '/2017',
          role: 'Web integration',
          stack: ['Html', 'Css', 'Jquery'],
          video: require('@/assets/sebV.mp4'),
          image: require('@/assets/seb.png'),
        },
        {
          title: 'Heart@Hack',
          description:
            "Intégration d'une landing page pour le lancement du jeu mobile Heart@Hack.",
          date: '/2017',
          role: 'Web integration/Web Design',
          stack: ['Html', 'Css', 'Jquery'],
          video: require('@/assets/hah.mp4'),
          image: require('@/assets/hah.png'),
        },
      ].map((project, index) => ({ ...project, id: index + 1 })),
      isTouchDevice: false,
    };
  },

  beforeRouteUpdate(to, from, next) {
    console.log('into');
    const toDepth = to.path.split('/').length;
    const fromDepth = from.path.split('/').length;
    this.transitionName = toDepth < fromDepth ? 'slide-left' : 'slide-right';
    next();
  },
  getters: {
    getProjectById: state => id => {
      return state.projects.find(project => project.id === id);
    },
  },
});

const app = createApp(App);
app.use(router);
app.use(store);
app.mount('#app');
